import { Questionnaire } from '@lib/types';
import { createReducer, on } from '@ngrx/store';
import produce from 'immer';
import * as RestaurantManagerActions from '../actions/restaurant-manager.actions';

export const restaurantManagerFeatureKey = 'restaurantManager';

export interface State {
  questionnaire: Questionnaire | null;
}

export const initialState: State = {
  questionnaire: null,
};

export const reducer = createReducer(
  initialState,

  on(RestaurantManagerActions.loadQuestionnaire, state => state),
  on(RestaurantManagerActions.loadQuestionnaireSuccess, (state, action) => {
    return produce(state, (draftState) => {
      draftState.questionnaire = action.questionnaire;
    });
  }),
  on(RestaurantManagerActions.loadQuestionnaireFailure, (state, action) => state),
  on(RestaurantManagerActions.updateQuestionnaire, state => state),
  on(RestaurantManagerActions.updateQuestionnaireSuccess, (state, action) => {
    return produce(state, (draftState) => {
      draftState.questionnaire = action.questionnaire;
    });
  }),
  on(RestaurantManagerActions.updateQuestionnaireFailure, (state, action) => state),

);
